import {hasValue} from 'web-app/util/typescript';

import {
    type AdditionalData,
    type AdditionalDataForMessage,
    NotificationType,
    type PushNotification,
    type MessagePushNotification,
} from './types';

const additionalDataIsForMessage = (additionalData: AdditionalData): additionalData is AdditionalDataForMessage =>
    additionalData.type === NotificationType.MESSAGE_CREATED;

export const notificationIsAboutUpdatedConversation = (
    notification: PushNotification,
): notification is MessagePushNotification =>
    hasValue(notification.additionalData) && additionalDataIsForMessage(notification.additionalData);

export const conversationIdFromNotification = (notification: PushNotification) =>
    notificationIsAboutUpdatedConversation(notification) ? notification.additionalData.conversationId : undefined;
